import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// sessionStorage is per tab and survives reloads, same as the browser history it describes
const STORAGE_KEY = 'historyEntryCompany'
// Oldest entries are dropped first; they are the least likely to be revisited
const MAX_ENTRIES = 200

const readEntries = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) ?? {}
  } catch {
    return {}
  }
}

// Remembers which company each history entry was opened in, so browser Back/Forward after a
// company switch can't render a page (e.g. a document) of the previously active company.
export const useIsStaleCompanyEntry = (companyId) => {
  const { key } = useLocation()

  // 'default' is shared by every entry loaded without router state (first load, typed URL)
  const isTracked = !!companyId && key !== 'default'
  const entryCompanyId = isTracked ? readEntries()[key] : undefined
  const isStale = entryCompanyId !== undefined && entryCompanyId !== companyId

  useEffect(() => {
    if (!isTracked || isStale) return

    try {
      const entries = Object.entries(readEntries())
        .filter(([entryKey]) => entryKey !== key)
        .slice(-(MAX_ENTRIES - 1))
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries([...entries, [key, companyId]])))
    } catch {
      // Storage unavailable: entries just stay untracked
    }
  }, [key, companyId, isTracked, isStale])

  return isStale
}
